module.exports = __webpack_public_path__ + "img/ignacio-bordigoni.a79c9052.jpg";